import { render, staticRenderFns } from "./brand_edit.vue?vue&type=template&id=3cfe132e&scoped=true"
import script from "./brand_edit.vue?vue&type=script&lang=js"
export * from "./brand_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe132e",
  null
  
)

export default component.exports